import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import logo from '../../assets/images/logo.png';

const variants = {
  open: {
    opacity: 0.8,
    transition: {
      type: 'spring',
      stiffness: 20,
      restDelta: 2,
    },
  },
  closed: {
    opacity: 0,
  },
};

const Logo = styled(motion.img)`
  padding: 0.1em;
  object-fit: contain;
  height: 100%;
  margin-left: 2em;
  opacity: 0.8;
`;

const DefaultLogo = () => (
    <Logo variants={variants} src={logo} alt={'LaVilla Logo'} />
);

export default DefaultLogo;
